// extracted by mini-css-extract-plugin
export default {"header":"XK","discountBanner":"YK","logo":"ZK","maincontainer":"aL","videocontainer":"bL","videowelcome":"cL","videowrapper":"eL","videosale":"fL","loadingcontainer":"gL","footer":"hL","footerbutton":"iL","video":"jL","logoname":"kL"};
    if(module.hot) {
      // 1738836197132
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  